/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  function watchNavigationScroll() {
    if( $(window).scrollTop() > 0 ) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }
  }

  function watchSlickDots() {
    setTimeout(function() {
      $('.slick-dots').each(function() {
        $(this).attr('data-dots-count', $(this).find('li').length);
      });
    }, 300);
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        watchNavigationScroll();

        $(window).on('load resize scroll', function() {
          watchNavigationScroll();
        });

        $('#navigation').on('show.bs.collapse', function() {
          $('body').addClass('menu-on');
        });

        $('#navigation').on('hide.bs.collapse', function() {
          $('body').removeClass('menu-on');
        });

        $('.logos-carousel').slick({
          autoplay: true,
          autoplaySpeed: 3000,
          slidesToShow: 5,
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 728,
              settings: {
                slidesToShow: 3,
                arrows: false
              }
            }
          ]
        });

        $('.modal').on('shown.bs.modal', function (e) {
          $(this).find('.slick-slider').slick('setPosition');
        });

        $(document).on('click', '.projects-list a', function(e) {
          e.preventDefault();

          var button = $(this),
              parent = button.closest('.article');

          if(parent.hasClass('loading') || !button.attr('data-id')) {
            return false;
          }

          $.ajax({
            type : 'POST',
            url : js_vars.ajaxurl,
            data : {
              'action': 'load_project_details',
              'project': button.attr('data-id')
            },
            beforeSend: function() {
              parent.addClass('loading');
            },
            success : function(data){
              if(data.html) {
                $('#project-modal .modal-body').html( data.html );

                $('#project-modal .project-images').slick({
                  dots: true,
                  arrows: false
                });

                $('#project-modal').modal('show');
        
                watchSlickDots();
              }
            },
            complete: function(){
              parent.removeClass('loading');
            },
            dataType : 'json'
          });
        });

        $('.single-project-details .project-images').slick({
          dots: true,
          arrows: false
        });

        $('.section-images-gallery .images-gallery').magnificPopup({
          delegate: 'a',
          type: 'image',
          tLoading: 'Loading image #%curr%...',
          mainClass: 'mfp-with-zoom mfp-img-mobile',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1] // Will preload 0 - before current, and 1 after the current image
          },
          image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
            titleSrc: function(item) {
              return item.el.find('img').attr('alt');
            }
          }
        });

        watchSlickDots();
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
